/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import {ChannelState} from '@phenixrts/sdk';

export class ParentWindowNotifier {
  _disposableSubscriptions = [];
  _wasPlaying = false;

  constructor({channelId, channel}) {
    this._initialize(channelId, channel);
  }

  dispose() {
    while (this._disposableSubscriptions.length) {
      this._disposableSubscriptions.pop().dispose();
    }
  }

  _initialize(channelId, channel) {
    const notifyParent = message => window.parent.postMessage(message, '*');
    const channelExistsObserver = exists => {
      // Note: null indicates JsSDK has not determined the existence of the channel yet.
      switch (exists) {
        case null:
          break;

        case false:
          notifyParent({
            channelId,
            action: 'joinChannel',
            type: 'joinChannelCallback',
            status: 'room-not-found'
          });

          break;

        case true:
          notifyParent({
            channelId,
            action: 'joinChannel',
            type: 'joinChannelCallback',
            status: 'ok'
          });

          break;

        default:
          break;
      }
    };

    const channelStateObserver = state => {
      switch (state) {
        case ChannelState.Error: {
          notifyParent({
            channelId,
            action: 'joinChannel',
            type: 'subscriberCallback',
            error: 'Error: Channel state is Error'
          });

          break;
        }

        case ChannelState.Playing: {
          this._wasPlaying = true;

          notifyParent({
            channelId,
            action: 'joinChannel',
            type: 'subscriberCallback',
            status: 'ok'
          });

          break;
        }

        case ChannelState.StandBy: {
          if (this._wasPlaying) {
            this._wasPlaying = false;

            notifyParent({
              channelId,
              action: 'joinChannel',
              type: 'subscriberCallback',
              status: 'stream-ended'
            });
          }

          notifyParent({
            channelId,
            action: 'joinChannel',
            type: 'subscriberCallback',
            status: 'no-stream-playing'
          });

          break;
        }

        default:
          break;
      }
    };

    this._disposableSubscriptions.push(
      channel.exists.subscribe(channelExistsObserver),
      channel.state.subscribe(channelStateObserver)
    );
  }
}